/**
 * Voice status helpers
 * Shared status type and avatar ring styling for voice participants.
 */

export type VoiceStatus = 'speaking' | 'active' | 'muted' | 'deafened' | 'screen_sharing';

/**
 * Get status ring classes for avatar
 */
export function getStatusRingClass(status: VoiceStatus, isSpeaking: boolean): string {
  if (isSpeaking && status === 'speaking') {
    return 'ring-2 ring-green-400 bg-green-500/20 animate-pulse';
  }

  switch (status) {
    case 'speaking':
    case 'active':
      return 'ring-2 ring-green-400/50 bg-gray-700';
    case 'muted':
      return 'ring-2 ring-red-400 bg-red-500/20';
    case 'deafened':
      return 'ring-2 ring-gray-500 bg-gray-700';
    case 'screen_sharing':
      return 'ring-2 ring-blue-400 bg-blue-500/20';
    default:
      return 'ring-2 ring-gray-500 bg-gray-700';
  }
}
